import { I18n } from '@calendly/i18n';
import { TagText, DeleteTagButton } from '@calendly/tags';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { Icon } from '@calendly/ui/components/icon';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { isEnterKey, isSpaceKey } from 'services/keycodes';
const styledTagTextIsInvalidCss = "snwysj4";
const styledTagTextCss = "s111pazf";
const StyledTagText = forwardRef((props, ref) => {
  const {
    isInvalid,
    ...restProps
  } = props;
  return <TagText ref={ref} {...restProps} className={classNames(styledTagTextCss, {
    [styledTagTextIsInvalidCss]: isInvalid
  }, props.className)} />;
});
const styledDeleteTagButtonIsInvalidCss = "s1p68wuj";
const styledDeleteTagButtonCss = "s1o4c0ro";
const StyledDeleteTagButton = forwardRef((props, ref) => {
  const {
    isInvalid,
    ...restProps
  } = props;
  return <DeleteTagButton ref={ref} {...restProps} className={classNames(styledDeleteTagButtonCss, {
    [styledDeleteTagButtonIsInvalidCss]: isInvalid
  }, props.className)} />;
});
export const NormalView = ({
  name,
  onDelete,
  toggleView,
  isInvalid
}) => {
  const handleKeyDown = useCallback(handler => event => {
    if (isEnterKey(event) || isSpaceKey(event)) {
      handler();
      event.preventDefault();
    }
  }, []);
  const handleMouseDown = useCallback(event => {
    toggleView();
    event.preventDefault();
    event.stopPropagation();
  }, [toggleView]);
  return <>
      <StyledTagText
    // This has to be a div to be able to receive focus in Safari by Tab keypress or click
    // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
    // https://bugs.webkit.org/show_bug.cgi?id=22261
    as="div" role="button" tabIndex={0} isInvalid={isInvalid} onClick={handleMouseDown} onKeyDown={handleKeyDown(toggleView)}>
        <FullStoryMask><span>{name}</span></FullStoryMask>
      </StyledTagText>
      <StyledDeleteTagButton aria-label={I18n.t('action.remove')}
    // Same as above ^
    as="div" role="button" tabIndex={0} isInvalid={isInvalid} onClick={onDelete} onKeyDown={handleKeyDown(onDelete)}>
        <Icon name="close" />
      </StyledDeleteTagButton>
    </>;
};

require("./normal_view.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./normal_view.js");